import { GridColDef } from "@mui/x-data-grid-pro";
import ItemStatus from "../../../../../../common/components/item_status";
import { IconButton } from "@mui/material";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";

/**
 * GenerateColumns
 */

type Props = {
  onActionEdit: (idMotivoDemissao: number | null, openState: boolean) => void,
  onActionDelete: (idMotivoDemissao: number | null, openState: boolean) => void,
};

export const GenerateMotivoDemissaoColumns = ({
  onActionEdit,
  onActionDelete,
}: Props): GridColDef[] => {
  const computeItemStatusTitle = (status: number) => {
    switch (status) {
      case 1:
        return "A";
      case 0:
        return "I";
      default:
        return "?";
    }
  };

  const computeItemStatusColor = (status: number) => {
    switch (status) {
      case 1:
        return "green";
      case 0:
        return "red";
      default:
        return "blue";
    }
  };

  const computeItemStatusDescription = (status: number) => {
    switch (status) {
      case 1:
        return "Ativo";
      case 0:
        return "Inativo";
      default:
        return "?";
    }
  };

  return [
    {
      field: "ativo",
      filterable: false,
      headerName: "Status",
      minWidth: 75,
      width: 75,
      sortable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex justify-center items-center">
          <ItemStatus
            title={computeItemStatusTitle(params.value ? 1 : 0)}
            color={computeItemStatusColor(params.value ? 1 : 0)}
            description={computeItemStatusDescription(params.value ? 1 : 0)} />
        </div>
      )
    },
    {
      field: "descricaoMotivo",
      filterable: false,
      headerName: "Nome",
      flex: 1,
      minWidth: 150,
      sortable: false,
    },
    {
      field: 'idMotivoDemissao',
      sortable: false,
      filterable: false,
      headerName: 'Ações',
      minWidth: 100,
      renderCell: (params) => {
        return (
          <div className="flex items-center justify-center w-full h-full gap-2">
            <IconButton onClick={() => onActionEdit(params.value, true)}>
              <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
            </IconButton>

            <IconButton onClick={() => onActionDelete(params.value, true)}>
              <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
            </IconButton>
          </div>
        );
      }
    }
  ];
}